<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 24 24">
    <g transform="translate(2.5 0.1) rotate(15) scale(0.215 0.215)">
      <path
        d="M 60.453 29.767 c -4.971 -4.454 -11.394 -6.499 -18.088 -5.76 c -11.024 1.218 -19.632 10.146 -20.469 21.229 c -0.504 6.674 1.879 13.233 6.537 17.996 c 2.02 2.065 3.132 4.903 3.132 7.991 v 15.05 c 0 2.055 1.672 3.727 3.727 3.727 h 19.415 c 2.055 0 3.727 -1.672 3.727 -3.727 V 70.989 c 0 -2.91 1.117 -5.713 3.066 -7.688 c 4.303 -4.363 6.672 -10.141 6.672 -16.268 C 68.172 40.453 65.358 34.16 60.453 29.767 z"
        :stroke="iconStroke"
        stroke-width="1.5"
        fill="none"
      />
      <path
        d="M 45 18.487 c -0.552 0 -1 -0.448 -1 -1 V 1 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 16.487 C 46 18.04 45.552 18.487 45 18.487 z"
        :fill="iconStroke"
      />
      <path
        d="M 59.64 22.312 c -0.17 0 -0.342 -0.043 -0.499 -0.134 c -0.479 -0.276 -0.643 -0.888 -0.366 -1.366 l 8.194 -14.193 c 0.276 -0.479 0.889 -0.643 1.366 -0.366 c 0.479 0.276 0.643 0.888 0.366 1.366 l -8.194 14.193 C 60.321 22.133 59.985 22.312 59.64 22.312 z"
        :fill="iconStroke"
      />
      <path
        d="M 30.36 22.312 c -0.346 0 -0.682 -0.179 -0.867 -0.5 L 21.299 7.619 c -0.276 -0.479 -0.112 -1.09 0.366 -1.366 c 0.479 -0.276 1.089 -0.112 1.366 0.366 l 8.194 14.193 c 0.276 0.479 0.112 1.09 -0.366 1.366 C 30.701 22.269 30.529 22.312 30.36 22.312 z"
        :fill="iconStroke"
      />
      <path
        d="M 70.589 32.897 c -0.346 0 -0.682 -0.179 -0.867 -0.5 c -0.276 -0.479 -0.112 -1.09 0.366 -1.366 l 13.964 -8.062 c 0.476 -0.276 1.089 -0.113 1.366 0.366 c 0.276 0.479 0.112 1.09 -0.366 1.366 l -13.964 8.062 C 70.931 32.854 70.759 32.897 70.589 32.897 z"
        :fill="iconStroke"
      />
      <path
        d="M 19.183 32.765 c -0.169 0 -0.341 -0.043 -0.499 -0.134 l -13.735 -7.93 c -0.479 -0.276 -0.642 -0.888 -0.366 -1.366 c 0.276 -0.479 0.886 -0.643 1.366 -0.366 l 13.735 7.93 c 0.479 0.276 0.642 0.888 0.366 1.366 C 19.864 32.586 19.528 32.765 19.183 32.765 z"
        :fill="iconStroke"
      />
      <path
        d="M 60.076 61.896 c -2.141 2.171 -3.424 5.173 -3.606 8.327 H 33.52 c -0.22 -3.224 -1.492 -6.176 -3.657 -8.39 c -4.256 -4.352 -6.433 -10.346 -5.973 -16.447 c 0.764 -10.124 8.626 -18.279 18.694 -19.392 c 0.82 -0.091 1.636 -0.136 2.445 -0.136 c 5.225 0 10.155 1.874 14.089 5.397 c 4.482 4.014 7.053 9.764 7.053 15.776 C 66.172 52.632 64.007 57.91 60.076 61.896 z"
        fill="#FFE53A"
      />
      <path
        d="M 57.777 45.543 c -0.553 0 -1 -0.448 -1 -1 c 0 -3.345 -1.43 -6.543 -3.924 -8.776 c -2.527 -2.264 -5.792 -3.303 -9.199 -2.927 c -0.538 0.059 -1.043 -0.334 -1.104 -0.884 c -0.061 -0.549 0.335 -1.043 0.884 -1.104 c 3.919 -0.43 7.839 0.815 10.753 3.425 c 2.916 2.612 4.589 6.354 4.589 10.267 C 58.777 45.095 58.33 45.543 57.777 45.543 z"
        :fill="iconStroke"
      />
      <path
        d="M 56.434 72.224 v 3.963 h -3.417 c -0.553 0 -1 0.447 -1 1 s 0.447 1 1 1 h 3.417 v 3.963 H 33.566 v -3.963 H 47.59 c 0.553 0 1 -0.447 1 -1 s -0.447 -1 -1 -1 H 33.566 v -3.963 H 56.434 z"
        fill="#C6C2C2"
      />
      <path
        d="M 54.707 88 H 35.292 c -0.952 0 -1.727 -0.774 -1.727 -1.727 v -2.124 h 22.868 v 2.124 C 56.434 87.226 55.659 88 54.707 88 z"
        fill="#C6C2C2"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '24',
    },
    width: {
      type: String,
      default: '24',
    },
    color: {
      type: String,
      default: 'primary-gray-700',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconStroke() {
      return `var(--${this.color})`
    },
  },
}
</script>
